import * as types from './types';
import { firebase } from 'src/firebase';
import { AdminEntity } from 'src/firebase/db/Admins';
import { APISuccessfulResponse, APIFailedResponse } from 'src/firebase/db/DatabaseAdapter';

export type Actions =
  | IsLogin
  | IsLogout
  | Login
  | SuccessLogin
  | FailLogin
  | Logout
  | SuccessLogout
  | FailLogout
  | ChooseSingInShop
  | SendForgetPassWordEmail
  | SuccessForgetPassWordEmail
  | FailForgetPassWordEmail;

interface IsLogin {
  type: typeof types.IS_LOGIN;
  payload: APISuccessfulResponse<AdminEntity>;
}
export const isLogin = (payload: IsLogin['payload']) => ({
  type: types.IS_LOGIN,
  payload,
});

interface IsLogout {
  type: typeof types.IS_LOGOUT;
  payload: { error: firebase.auth.Error };
}
export const isLogout = (payload: IsLogout['payload']) => ({
  type: types.IS_LOGOUT,
  payload,
});

interface Login {
  type: typeof types.LOGIN;
  payload: { email: string; password: string };
}
export const login = (payload: Login['payload']) => ({
  type: types.LOGIN,
  payload,
});

interface SuccessLogin {
  type: typeof types.SUCCESS_LOGIN;
  payload: APISuccessfulResponse<AdminEntity>;
}
export const successLogin = (payload: SuccessLogin['payload']) => ({
  type: types.SUCCESS_LOGIN,
  payload,
});

interface FailLogin {
  type: typeof types.FAIL_LOGIN;
  payload: APIFailedResponse;
}
export const failLogin = (payload: FailLogin['payload']) => ({
  type: types.FAIL_LOGIN,
  payload,
});

interface Logout {
  type: typeof types.LOGOUT;
}
export const logout = () => ({
  type: types.LOGOUT,
});

interface SuccessLogout {
  type: typeof types.SUCCESS_LOGOUT;
}
export const successLogout = () => ({
  type: types.SUCCESS_LOGOUT,
});

interface FailLogout {
  type: typeof types.FAIL_LOGOUT;
  payload: APIFailedResponse;
}
export const failLogout = (payload: FailLogout['payload']) => ({
  type: types.FAIL_LOGOUT,
  payload,
});

interface ChooseSingInShop {
  type: typeof types.CHOOSE_SIGNIN_SHOP;
  payload: string;
}

export const chooseSigninShop = (payload: ChooseSingInShop['payload']) => ({
  type: types.CHOOSE_SIGNIN_SHOP,
  payload,
});

interface SelectSingInShop {
  type: typeof types.SELECT_SIGNIN_SHOP;
  payload: string;
}

export const selectSigninShop = (payload: SelectSingInShop['payload']) => ({
  type: types.SELECT_SIGNIN_SHOP,
  payload,
});

interface SendForgetPassWordEmail {
  type: typeof types.SEND_FORGET_PASSWORD_MAIL;
  payload: string;
}

export const sendForgetPassWordEmail = (payload: SendForgetPassWordEmail['payload']) => ({
  type: types.SEND_FORGET_PASSWORD_MAIL,
  payload,
});

interface SuccessForgetPassWordEmail {
  type: typeof types.SUCCESS_FORGET_PASSWORD_MAIL;
  payload: APISuccessfulResponse<AdminEntity>;
}
export const successForgetPassWordEmail = (payload: SuccessForgetPassWordEmail['payload']) => ({
  type: types.SUCCESS_FORGET_PASSWORD_MAIL,
  payload,
});

interface FailForgetPassWordEmail {
  type: typeof types.FAIL_FORGET_PASSWORD_MAIL;
  payload: APIFailedResponse;
}
export const failForgetPassWordEmail = (payload: FailForgetPassWordEmail['payload']) => ({
  type: types.FAIL_FORGET_PASSWORD_MAIL,
  payload,
});
